import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, " Snap! Manage has been upgraded to provide enhanced functionality and improved security. Please create an account to continue. ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "p-4" }, " If you received an email/text invite, you must use the same email address or phone number to create your account. ", -1)
const _hoisted_5 = {
  key: 5,
  class: "mb-4 text-sm"
}
const _hoisted_6 = { key: 6 }
const _hoisted_7 = { class: "social-login" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, [
  /*#__PURE__*/_createElementVNode("span", null, "or")
], -1)
const _hoisted_9 = {
  key: 7,
  class: "mt-10 text-right md:text-center text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_InlineLink = _resolveComponent("InlineLink")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_Link = _resolveComponent("Link")!
  const _component_GoogleSignInButton = _resolveComponent("GoogleSignInButton")!
  const _component_RegistrationForm = _resolveComponent("RegistrationForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showInviteParentAlert && !_ctx.publicFundraiserData)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 0,
          type: "info",
          class: "mb-6 md:absolute md:top-8 md:inset-x-8 z-10"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Sign up to help " + _toDisplayString(_ctx.inviteRequester?.firstName) + " " + _toDisplayString(_ctx.inviteRequester?.lastName) + " with their fundraiser. ", 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showInviteParentAlert && _ctx.publicFundraiserData)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 1,
          type: "info",
          class: "mb-6 md:absolute md:top-8 md:inset-x-8 z-10"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Sign up to help " + _toDisplayString(_ctx.inviteRequester?.firstName) + " " + _toDisplayString(_ctx.inviteRequester?.lastName) + " with their " + _toDisplayString(_ctx.publicFundraiserData.name) + " fundraiser. ", 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showInviteUserAlert)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 2,
          type: "info",
          class: "mb-6 md:absolute md:top-8 md:inset-x-8 z-10"
        }, {
          default: _withCtx(() => [
            _createTextVNode("You have an invite to Snap! Mobile. Please sign up to accept it. ")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showManageAlert)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 3,
          type: "info",
          class: "mb-6 md:absolute md:top-8 md:inset-x-8 z-10"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2,
            (_ctx.manageRegistrationLink)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                  _createVNode(_component_InlineLink, {
                    href: _ctx.manageRegistrationLink,
                    size: "sm",
                    target: '_blank'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Click Here to Browse Camps. ")
                    ]),
                    _: 1
                  }, 8, ["href"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ('parent_modal' in this.$route.query)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 4,
          wideCloseButton: "true",
          type: "warning"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_PageTitle, { class: "mb-3 md:mb-4" }, {
      default: _withCtx(() => [
        _createTextVNode("Create Your Snap! Mobile Account")
      ]),
      _: 1
    }),
    (_ctx.featureOn?.('USER-888-new-sign-up-view'))
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
          _createTextVNode(" Have an account? "),
          _createVNode(_component_Link, {
            to: { name: 'login' },
            size: "sm"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Sign in")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.showGoogleSignIn)
      ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_GoogleSignInButton)
          ]),
          _hoisted_8
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_RegistrationForm, {
      class: "pt-4",
      "onForm:error": _ctx.onFormError,
      prefill: _ctx.prefillRegistrationData
    }, null, 8, ["onForm:error", "prefill"]),
    (!_ctx.featureOn?.('USER-888-new-sign-up-view'))
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
          _createTextVNode(" Already have Snap! Mobile account? "),
          _createVNode(_component_Link, {
            to: { name: 'login' },
            size: "sm"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Sign in here.")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}